import { render, staticRenderFns } from "./phone_validation.vue?vue&type=template&id=3e25e55f"
import script from "./phone_validation.js?vue&type=script&lang=js&external"
export * from "./phone_validation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports